import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ROUTES } from './configuration/sidenav-routes.config';
import { IUser } from 'src/app/shared/models/login.model';
import { UserService } from '@shared/services/user.service';
import { SessionStorageService } from 'src/app/main/orders/services/session-storage.service';

const BLACK_LIST = ['gp@ritewayautotransport.com'];

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {
  @ViewChild('toggleIcon', { static: false }) toggleIcon: ElementRef;

  public menuItems: any[];
  public user: IUser;
  depth: number;
  activeTitles: string[] = [];
  expanded: boolean;
  navCollapsedOpen = false;
  logoUrl = 'assets/images/logos/log_logo.svg';
  public config: any = {};

  constructor(
    private userService: UserService,
    private sessionStorage: SessionStorageService
  ) {
    this.user = this.userService.userInfo;
    if (this.depth === undefined) {
      this.depth = 0;
      this.expanded = true;
    }
  }

  ngOnInit() {
    const modules = this.userService.userModulesInfo
      ? this.userService.userModulesInfo
      : [];

    let menuItems = [];

    // Verify modules by privileges
    Object.keys(modules).forEach(key => {
      if (
        modules[key] &&
        modules[key].active &&
        ROUTES.some(route => route.title.toLowerCase() == key) &&
        !menuItems.some(route => route.title.toLowerCase() == key)
      ) {
        menuItems.push(ROUTES.find(route => route.title.toLowerCase() == key));
      }
    });

    // Add modules without privileges
    ROUTES.forEach(route => {
      if (
        ['/main/dashboard', '/main/tiers'].includes(route.path) &&
        route[this.user.role.name]
      ) {
        menuItems.push(route);
      }
    });

    if (BLACK_LIST.includes(this.user.username)) {
      menuItems = menuItems.filter(x => x.path !== '/main/dashboard');
    }

    this.menuItems = menuItems.sort((a, b) => a.position - b.position);
    this.clearModuleStorage();
  }

  toggleSlideInOut() {
    this.expanded = !this.expanded;
  }

  handleToggle(titles) {
    this.activeTitles = titles;
  }

  clearModuleStorage() {
    this.sessionStorage.cleanAll();
  }
}
